import { useContext } from 'react';

import type { TLeasingOrderResponse } from '@/components/App/Leasing/types';
import { Button } from '@/components/Shared/ui';
import { useAppDispatch } from '@/store';

import { IeLeasingOrderContext } from '../../IeOrder';
import { useSelectedOffer } from '../../hooks';
import { setActiveTabIndex } from '../../store';
import { OfferStepContext } from '../offer-step';

interface IProps {
  leasingOffer: TLeasingOrderResponse;
}

const useLeasingHeaderActions = ({ leasingOffer }: IProps) => {
  const dispatch = useAppDispatch();
  const { isActionsDisabled } = useContext(IeLeasingOrderContext);
  const { onAcceptLeasingOffer } = useContext(OfferStepContext);

  const { selectedOffer } = useSelectedOffer();

  const canAccept =
    leasingOffer.status.code === 'approved' ||
    leasingOffer.status.code === 'accepted_alternative';

  const headerActions: React.ReactElement[] = [];
  if (selectedOffer) {
    headerActions.push(
      <Button
        key={leasingOffer.uuid + 'continue'}
        size="small"
        variant="filled-red"
        onClick={() => dispatch(setActiveTabIndex(2))}
      >
        Продолжить
      </Button>
    );
  } else if (canAccept || leasingOffer.status.code === 'client_accepted') {
    headerActions.push(
      <Button
        key={leasingOffer.uuid + 'accept'}
        size="small"
        variant="filled-red"
        onClick={() => {
          onAcceptLeasingOffer(leasingOffer);
        }}
        disabled={isActionsDisabled}
      >
        Принять <span className="ie-offer-step__hidden">предложение</span>
      </Button>
    );
  }
  return { headerActions };
};

export default useLeasingHeaderActions;
